import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../../../_globals';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ImagesService } from '../../../../_services/images.service';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'app-product-media-form-dialog',
  templateUrl: './product-media-form.component.html',
})
export class ProductMediaFormComponent implements OnInit, OnDestroy {
  @Input() product: any;
  @Input() store: any;
  @Output() updateProduct = new EventEmitter();

  allImages: any[] = [];

  imageBaseUrl = '';
  showImageBank = false;
  imageBankType = null;

  imageBase64: any;

  constructor(
    public globals: Globals,
    public router: Router,
    public fb: FormBuilder,
    public _imagesService: ImagesService,
    public confirmationService: ConfirmationService,
    public notificationService: NotificationService
  ) {}

  ngOnInit() {
    // console.log('product images product', this.product);

    this.imageBaseUrl = environment.dcSpacesUrl + 'images/' + this.store.id + '/';
  }

  addFeaturedImage() {
    console.log('add featured image');
    this.showImageBank = true;
    this.imageBankType = 'featured';
    this.getImages(this.store.id);
  }

  removeFeaturedImage(image) {
    // console.log('remove featured image from product', this.product);
    // console.log('remove featured image image', image);

    this.confirmationService.confirm({
      message:
        'Are you sure that you want to remove product featured image? It will not be deleted from Image bank.',
      accept: () => {
        const body = {
          imageId: image.id,
          itemFeaturedItemId: this.product.id,
        };

        this._imagesService.removeImageLink(body).subscribe((data: any) => {
          // console.log(data);
          this.updateProduct.emit(true);
        });
      },
    });
  }

  public uploadFeaturedImage(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file: File = event.target.files[i];
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        const fileObj = {
          fileName: event.target.files[i].name,
          imageBase64: loadEvent.target.result,
          itemCategoryId: null,
          itemFeaturedItemId: that.product.id,
          itemImageItemId: null,
          storeFeaturedImageStoreId: null,
          storeId: that.store.id,
          storeLogoStoreId: null,
        };
        that.imageBase64 = fileObj;
        that.uploadImage(fileObj);
      };
      myReader.readAsDataURL(file);
    }
  }

  addImage() {
    console.log('add image');
    this.showImageBank = true;
    this.imageBankType = 'other';
    this.getImages(this.store.id);
  }

  removeImage(image) {
    // console.log('remove image from product', this.product);
    // console.log('remove featured image image', image);

    this.confirmationService.confirm({
      message:
        'Are you sure that you want to remove product image? It will not be deleted from Image bank.',
      accept: () => {
        const body = {
          imageId: image.id,
          itemImageItemId: this.product.id,
        };

        this._imagesService.removeImageLink(body).subscribe((data: any) => {
          // console.log(data);
          this.updateProduct.emit(true);
        });
      },
    });
  }

  public uploadOtherImage(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file: File = event.target.files[i];
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        const fileObj = {
          fileName: event.target.files[i].name,
          imageBase64: loadEvent.target.result,
          itemCategoryId: null,
          itemFeaturedItemId: null,
          itemImageItemId: that.product.id,
          storeFeaturedImageStoreId: null,
          storeId: that.store.id,
          storeLogoStoreId: null,
        };
        that.imageBase64 = fileObj;
        that.uploadImage(fileObj);
      };
      myReader.readAsDataURL(file);
    }
  }

  closeImageBank() {
    console.log('close image bank');
    this.showImageBank = false;
    this.imageBankType = null;
    this.allImages = [];
  }

  getImages(id) {
    this.allImages = [];
    this._imagesService.getAllStoreImages(id).subscribe((data: any) => {
      console.log('get all images', data);
      this.allImages = data;
    });
  }

  imageDeleteEvent(e) {
    console.log('image delted', e);
    this.getImages(this.store.id);
  }

  imageSelectEvent(e) {
    console.log('select image', e);

    if (this.imageBankType === 'featured') {
      this._imagesService
        .addFeaturedImageToProduct(this.product.id, e.id)
        .subscribe((data: any) => {
          this.closeImageBank();
          this.updateProduct.emit(true);
          this.notificationService.notify(
            'success',
            'Image Updated',
            'Products Image has been updated',
            'top',
            'right'
          );
        });
    } else {
      this._imagesService.addImageToProduct(this.product.id, e.id).subscribe((data: any) => {
        this.closeImageBank();
        this.updateProduct.emit(true);
        this.notificationService.notify(
          'success',
          'Image Updated',
          'Products Image has been updated',
          'top',
          'right'
        );
      });
    }
  }

  uploadImage(fileObj) {
    this._imagesService.uploadImageToImageBank(fileObj).subscribe((data: any) => {
      this.updateProduct.emit(true);
      this.notificationService.notify(
        'success',
        'Image Updated',
        'Products Image has been updated',
        'top',
        'right'
      );
    });
  }

  ngOnDestroy() {
    this.updateProduct.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/products/product-media-form/product-media-form.component.ts